import React from 'react';
import { Text, View } from "../../Components/Themed"
import type { CampaignParticipantProps, EventProps, MatchProps, OrderAnalyticsProps, OrderProps, PublicPlayerProps, TournamentProps } from "../../types"
import { Image } from 'react-native';
import moment from 'moment-mini';
import ActionList from './ActionList';
import { CampaignHelpers } from '../api';
import AnalyticsCard from './AnalyticsCard';

type ParticipantCardProps = {
    campaign_participant:CampaignParticipantProps,
    player:PublicPlayerProps,
    orders:OrderProps[],
    tournaments:TournamentProps[],
    matches:MatchProps[],
    analytics:OrderAnalyticsProps[],
    events:EventProps[]
}
const ParticipantCard = ({ player, campaign_participant, orders, events, tournaments, matches, analytics }:ParticipantCardProps) => {
    const agg = CampaignHelpers.aggregateAnalytics(analytics);
    
    return (
        <View transparent style={{ marginTop:65, flex:1 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View float style={{ padding:2, borderRadius:100, marginTop:-65, marginLeft:10 }}>
                    <Image
                        source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                        style={{ height:100, width:100, borderRadius:100}}
                    />
                </View>
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>@{player.username}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{player.bio ?? `Last visited ${moment(campaign_participant.last_update_datetime).fromNow()}`}</Text>
                </View>
            </View>
            <View type='header' style={{ flexDirection:'row', padding:6 }}>
                <View transparent style={{ margin:4, flex:1 }}>
                    <AnalyticsCard
                        label='Bets Fulfilled'
                        value={agg.fulfilled_positions}
                        success_limit={0}
                        value_label={agg.fulfilled_positions.toString()}
                    />
                </View>
                <View transparent style={{ margin:4, flex:1 }}>
                    <AnalyticsCard
                        label='ROI %'
                        value={agg.roi_pct}
                        success_limit={0}
                        value_label={`${(agg.roi_pct * 100).toFixed(2)}%`}
                    />
                </View>
                <View transparent style={{ margin:4, flex:1 }}>
                    <AnalyticsCard
                        label={`Win %`}
                        value={agg.win_pct}
                        success_limit={0.5}
                        value_label={`${(agg.win_pct * 100).toFixed(2)}%`}
                    />
                </View>
               
            </View>
            <View transparent style={{ flex:1 }}>
                <View type='header' style={{ flexDirection:'row', padding:10 }}>
                    <View transparent style={{ flex:1 }}>
                        <Text theme='h1'>Recent Action</Text>
                        <Text theme='description' style={{ marginTop:4 }}>Bets recently placed by @{player.username}</Text>
                    </View>
                </View>
                <ActionList
                    orders={orders}
                    hide_header
                    tournaments={tournaments}
                    matches={matches}
                    players={[player]}
                    events={events}
                />
            </View>
        </View>
    )
}

export default ParticipantCard